import { render } from "./ResearchHome.vue?vue&type=template&id=0a29e322&scoped=true"
import script from "./ResearchHome.vue?vue&type=script&lang=js"
export * from "./ResearchHome.vue?vue&type=script&lang=js"

import "./ResearchHome.vue?vue&type=style&index=0&id=0a29e322&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a29e322"]])

export default __exports__